import React from "react";
import "./Frame1144.css";

function Frame1144(props) {
  const { className } = props;

  return (
    <div className={`frame-114-95 ${className || ""}`}>
      <div className="modeling-88 valign-text-middle inter-medium-sonic-silver-18px">Modeling</div>
    </div>
  );
}

export default Frame1144;
